module.exports = __webpack_public_path__ + "static/media/LVA.eb0a849d.svg";